import { Region } from '@enums/RegionList';

export const defaultPrice = 40_000;

export const ConfigPrice = {
  [Region.Moscow]: 60_000,
  [Region.SaintPetersburg]: 60_000,
  [Region.RostovOnDon]: 30_000,
};

export const hideRegion = [
  Region.Barnaul,
  Region.Yekaterinburg,
  Region.Perm,
  Region.Tomsk,
  Region.Petrozavodsk,
  Region.Krsk,
  Region.Hab,
  Region.RostovOnDon,

  Region.Togliatti,
  Region.Voronezh,
  Region.Ufa,
  Region.Volgograd,
  Region.Engels,
  Region.Salavat,
  Region.Sterlitamak,
];

export const ConfigPriceStore = {
  19: 500,
  33: 500,
  189: 500,
  200: 500,
  301: 500,
};
